import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

const LAST_UPDATE = "10 de febrero de 2026";
const COMPANY = "DoSoft SpA";
const CONTACT_EMAIL = "contacto@dosoft.cl";
const APP = "SIGSAOP — Sistema de Gestión Social y Ambiental para Operaciones y Proyectos";

export default function LegalLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="legal-page">
      <header className="bg-slate-950 text-white">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white" data-testid="back-home">
            <ArrowLeft size={16} /> Volver al inicio
          </Link>
          <img src="/assets/sigsaop-logo-light.svg?v=5" alt="SIGSAOP" className="h-8 w-auto" />
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-14">
        <div className="text-xs uppercase tracking-[0.22em] text-brand-orange-600 mb-3">Documento legal</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl">{subtitle}</p>}
        <div className="mt-4 text-xs text-slate-500">
          Última actualización: {LAST_UPDATE}
        </div>

        <article className="mt-10 max-w-none legal-doc space-y-4 text-slate-700 leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:tracking-tight [&_h2]:text-slate-900 [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-slate-900 [&_h3]:mt-6 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_p]:leading-relaxed [&_a]:text-brand-orange-600 hover:[&_a]:underline [&_code]:bg-slate-100 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-xs [&_code]:font-mono">
          {children}
        </article>

        <div className="mt-16 pt-8 border-t border-slate-200 text-sm text-slate-500 space-y-1">
          <div><strong className="text-slate-700">Responsable del tratamiento:</strong> {COMPANY}</div>
          <div><strong className="text-slate-700">Contacto DPO / Ejercicio de derechos:</strong> <a href={`mailto:${CONTACT_EMAIL}`} className="text-brand-orange-600 hover:underline">{CONTACT_EMAIL}</a></div>
          <div><strong className="text-slate-700">Plataforma:</strong> {APP}</div>
        </div>

        <div className="mt-10 flex flex-wrap gap-3 text-sm">
          <Link to="/terminos" className="text-slate-600 hover:text-brand-orange-600 underline underline-offset-2">Términos y Condiciones</Link>
          <span className="text-slate-300">·</span>
          <Link to="/privacidad" className="text-slate-600 hover:text-brand-orange-600 underline underline-offset-2">Política de Privacidad</Link>
          <span className="text-slate-300">·</span>
          <Link to="/cookies" className="text-slate-600 hover:text-brand-orange-600 underline underline-offset-2">Política de Cookies</Link>
        </div>
      </main>
    </div>
  );
}

export const LEGAL_META = { COMPANY, CONTACT_EMAIL, APP, LAST_UPDATE };
